<!-- 购物车 -->
<template>
  <div class="business-content-main buycar">
    <div class="bread-nav">
      <breadcrumb></breadcrumb>
    </div>
    <div v-if="tableDataLength!= 0" class="buycar-main">
      <div class="div-table-row order-title">
        <div class="div-table-cell">
          <el-checkbox v-model="checkAll" @change="chooseAll">全选</el-checkbox>
        </div>
        <div class="div-table-cell" style="width: 500px">商品</div>
        <div class="div-table-cell" style="width: 100px">单价</div>
        <!--                <div class="div-table-cell" style="width: 100px">库存</div>-->
        <div class="div-table-cell" style="width: 200px;text-align: center">数量</div>
        <div class="div-table-cell" style="width: 100px">小计</div>
        <div class="div-table-cell" style="width: 200px;border-right: 1px solid #EBEEF5">操作</div>
      </div>

      <div class="order-item" v-for="(item,index) in dataList" :key="index">
        <!-- 优惠活动 -->
        <div class="div-table-row">
          <div class="div-table-cell" style="width: 1275px;line-height: 50px">
            <div
              class="activity"
              v-if="item.SinglePromotion || item.BuyGivePromotion || item.FullDiscountPromotion || item.ExchangeBuyPromotion || item.isSuit"
            >
              <!-- 单品促销 -->
              <template v-if="item.SinglePromotion">
                <template v-if="item.SinglePromotion.DiscountType == 0">
                  <div class="promotion-item">
                    <div class="promotion-type">折扣</div>
                    <div class="promotion-dir">{{item.SinglePromotion.DiscountValue}}折</div>
                  </div>
                </template>
                <template v-else-if="item.SinglePromotion.DiscountType == 1">
                  <div class="promotion-item">
                    <div class="promotion-type">直降</div>
                    <div class="promotion-dir">{{item.SinglePromotion.DiscountValue}}元</div>
                  </div>
                </template>
                <template v-else-if="item.SinglePromotion.DiscountType == 2">
                  <div class="promotion-item">
                    <div class="promotion-type">折后价</div>
                    <div class="promotion-dir">{{item.SinglePromotion.DiscountValue}}元</div>
                  </div>
                </template>
              </template>
              <!-- 买送 -->
              <template v-if="item.BuyGivePromotion">
                <div class="promotion-item">
                  <div class="promotion-type">买送</div>
                  <div
                    class="promotion-dir"
                  >买{{item.BuyGivePromotion.BuyCount}}送{{item.BuyGivePromotion.SendCount}}</div>
                </div>
              </template>
              <!-- 满减 -->
              <template v-if="item.FullDiscountPromotion">
                <div class="promotion-item">
                  <div class="promotion-type">满减</div>
                  <div class="promotion-dir">
                    满{{item.FullDiscountPromotion.LimitMoney1}}减{{item.FullDiscountPromotion.CutMoney1}}
                    <template
                      v-if="item.FullDiscountPromotion.LimitMoney2"
                    >满{{item.FullDiscountPromotion.LimitMoney2}}减{{item.FullDiscountPromotion.CutMoney2}}</template>
                    <template
                      v-if="item.FullDiscountPromotion.LimitMoney3"
                    >满{{item.FullDiscountPromotion.LimitMoney3}}减{{item.FullDiscountPromotion.CutMoney3}}</template>
                  </div>
                </div>
              </template>
              <!-- 换购促销 -->
              <template v-if="item.ExchangeBuyPromotion">
                <div class="promotion-item show-hg-btn" @click="hgShow(item,index)">
                  <div class="promotion-type">换购</div>
                  <div
                    class="promotion-dir"
                  >满{{item.ExchangeBuyPromotion.LimitMoney}}加{{item.ExchangeBuyPromotion.AddMoney}}可换购</div>
                </div>
              </template>
              <!--  套装标识 -->
              <template v-if="item.isSuit">
                <div class="promotion-item">
                  <div class="promotion-type">套装</div>
                </div>
              </template>
            </div>
          </div>
        </div>
        <!-- 主体商品》套装 -->
        <div v-if="item.isSuit">
          <div class="div-table-row">
            <div class="div-table-cell" style="width:50px">
              <el-checkbox v-model="item.checked" @change="chooseItem(item,index)"></el-checkbox>
            </div>
            <div class="div-table-cell">
              <div>
                <div :key="index" v-for="(suit,index) in item.PackageGoodsList">
                  <div class="suit-item">
                    <div style="width:420px">
                      <div class="order-msg">
                        <div class="shop-cover image-ctn">
                          <img :src="down_url+suit.ShowImg" alt :onerror="defaultImg" />
                        </div>
                        <div
                          class="goods-name"
                          @click="gotoGoodsDetails(suit.GoodsId)"
                          :title="suit.Name"
                        >{{suit.Name}}</div>
                      </div>
                    </div>
                    <div style="width:120px">
                      <span class="suit-price">￥{{suit.zhMoney}}</span>
                      <span>x{{suit.Number}}</span>
                    </div>
                  </div>
                  <!-- 赠品 -->
                  <div class="suit-item" v-if="suit.GiftPromotion">
                    <template v-for="(gift,index) in suit.GiftPromotion.GiftGoodsList">
                      <div :key="index" style="width:420px">
                        <div class="order-msg">
                          <div class="gift-cover image-ctn">
                            <img :src="down_url + gift.ShowImg" />
                          </div>
                          <div class="goods-name">
                            <span class="goods-type-icon">赠品</span>
                            {{gift.Name}}
                          </div>
                        </div>
                      </div>
                      <div :key="index" style="width:80px">
                        <span class="suit-price">￥0</span>
                        <span>x{{gift.Number * item.BuyCount}}</span>
                      </div>
                      <div :key="index" style="width:100px"></div>
                    </template>
                  </div>
                </div>
              </div>
            </div>
            <div class="div-table-cell" style="width:140px">
              <inputNumber :index="index" :data="item" @change="handleNumChange"></inputNumber>
            </div>
            <div style="width:80px" class="div-table-cell color-red">￥{{item.zhMoneyCount}}</div>
            <div class="div-table-cell" style="width:207px">
              <el-button
                @click="delGoods(index)"
                type="text"
                size="small"
                v-if="permission.del"
              >{{permission.del}}</el-button>
            </div>
          </div>
        </div>
        <!-- 主体商品》单品 -->
        <div class="div-table-row" v-else>
          <div class="div-table-cell" style="border-bottom:none;width: 1275px;line-height: 50px">
            <div style="width:50px">
              <el-checkbox v-model="item.checked" @change="chooseItem(item,index)"></el-checkbox>
            </div>
            <div style="width:420px">
              <div class="order-msg">
                <div class="image-ctn shop-cover">
                  <img :src="down_url+item.ShowImg" alt :onerror="defaultImg" />
                </div>
                <div
                  class="goods-name"
                  @click="gotoGoodsDetails(item.GoodsId)"
                  :title="item.Name"
                >{{item.Name}}</div>
              </div>
            </div>
            <div style="width:120px">￥{{item.zhMoney}}</div>
            <!--                        <div style="width:100px">-->
            <!--                            {{item.InventoryQuantity}}-->
            <!--                        </div>-->
            <div class="goods-num" style="width:140px;padding-left: 0">
              <inputNumber :index="index" :data="item" @change="handleNumChange"></inputNumber>
            </div>
            <div style="width:100px" class="color-red">￥ {{item.zhMoneyCount|numHandle}}</div>
            <div class="border-right" style="width:207px">
              <el-button
                @click="delGoods(index)"
                type="text"
                size="small"
                v-if="permission.del"
              >{{permission.del}}</el-button>
            </div>
          </div>
        </div>
        <!-- 换购商品 -->
        <div class="suit-item div-table-row gift-type" v-if="item.hgGoods.Name">
          <div style="width:400px">
            <div class="order-msg">
              <div class="gift-cover image-ctn">
                <img :src="down_url + item.hgGoods.ShowImg" />
              </div>
              <div class="goods-name" :title="item.hgGoods.Name">
                <span class="goods-type-icon">加价购</span>
                {{item.hgGoods.Name}}
              </div>
            </div>
          </div>
          <div style="width:80px">￥{{item.hgGoods.ShopPrice}}&nbsp;&nbsp;&nbsp;&nbsp;x1</div>
          <div style="width:100px">-</div>
        </div>
        <!-- 买送商品 -->
        <div class="suit-item div-table-row gift-type" v-if="item.canMs">
          <div style="width:400px">
            <div class="order-msg">
              <div class="image-ctn gift-cover">
                <img :src="down_url + item.ShowImg" />
              </div>
              <div class="goods-name" :title="item.Name">
                <span class="goods-type-icon">买送</span>
                {{item.Name}}
              </div>
            </div>
          </div>
          <div style="width:80px">￥0&nbsp;&nbsp;&nbsp;&nbsp;x{{item.msNum}}</div>
        </div>
        <!-- 赠品 -->
        <div class="suit-item div-table-row gift-type" v-if="item.GiftPromotion">
          <template v-for="(gift,index) in item.GiftPromotion.GiftGoodsList">
            <div :key="index" style="width:400px">
              <div class="order-msg">
                <div class="gift-cover image-ctn">
                  <img :src="down_url + gift.ShowImg" />
                </div>
                <div class="goods-name" :title="gift.Name">
                  <span class="goods-type-icon">赠品</span>
                  {{gift.Name}}
                </div>
              </div>
            </div>
            <div
              :key="index"
              style="width:80px"
            >￥0&nbsp;&nbsp;&nbsp;&nbsp;x{{gift.Number * item.BuyCount}}</div>
            <div :key="index" style="width:100px">-</div>
          </template>
        </div>
      </div>

      <div class="order-footer">
        <div class="del-ctn" v-if="permission.delAll">
          <el-checkbox v-model="checkAll" @change="chooseAll">全选</el-checkbox>
          <div class="del-goods" @click="delCarMult">{{permission.delAll}}</div>
        </div>
        <div class="order-footer-right">
          <div>
            已选择
            <span class="color-red">{{checkedNum}}</span> 件商品
          </div>
          <div class="all-money">
            <p>
              &nbsp;总价：
              <span class="color-red">￥{{checkedPrice}}</span>
            </p>
            <p>已节省：￥{{checkedOriginalPrice - checkedPrice | numHandle}}</p>
          </div>
          <div
            class="pay-btn"
            @click="gotoOrderInfo"
            v-if="permission.gotoPay"
          >{{permission.gotoPay}}</div>
        </div>
      </div>
    </div>
    <div v-else class="no-data">咦，你的购物车居然是空的</div>
    <el-dialog :close-on-click-modal="false" width="800px" title="选择换购商品" :visible.sync="showHg">
      <div class="goods-main hg-goods" v-for="(item,index) in hgList" :key="index">
        <div style="width:50px">
          <el-checkbox v-model="item.checked"></el-checkbox>
        </div>
        <div style="width:400px">
          <div class="order-msg">
            <div class="gift-cover image-ctn">
              <img :src="down_url + item.ShowImg" />
            </div>
            <div title="item.Name">{{item.Name}}</div>
          </div>
        </div>
        <div style="width:80px">￥{{item.ShopPrice}}&nbsp;&nbsp;&nbsp;&nbsp; x1</div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showHg = false">取 消</el-button>
        <el-button class="btn-primary" @click="addHg">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import breadcrumb from "@/components/common/breadcrumb";
import inputNumber from "@/components/common/inputNumber";
import mixin from "@/mixins/mixin";
export default {
  mixins: [mixin],
  name: "",
  components: {
    inputNumber,
    breadcrumb
  },
  data() {
    let userMsg = this.$util.getLocalStorage("userMsg");
    return {
      userMsg:userMsg,
      defaultImg: 'this.src="' + this.$util.DEFAULT_IMAGE + '"',
      tableDataLength: 0,
      nowHgIndex: -1, // 当前执行换购商品的索引
      nowHgChosen: false,
      hgList: [], // 这个是动态变的
      showHg: false,
      showPromotion: false, // 促销
      dataList: [], // 商品和套装列表
      checkedList: [], // 选中的商品和套装列表
      checkedNum: 0, // 选中的商品和套装的数量
      checkedPrice: 0, // 选中的商品和套装的折后总价
      checkedOriginalPrice: 0, // 选中的商品和套装的原价
      down_url: this.$util.QN_URL_BASE,
      noData: false,
      checkAll: false,
      promotionData: {},
      promotionIndex: -1,
      promotionLayer: {}, // 促销弹窗数据
      permission: {}
    };
  },
  watch: {
    refreshShopCar() {
      this.getData();
    }
  },
  filters: {
    numHandle(value) {
      return parseFloat(value).toFixed(2);
    }
  },
  mounted() {
    this.getData();
    this.permission = this.$util.getPermission("ShopCarList");
  },
  activated() {
    this.getData();
  },
  computed: {
    refreshShopCar() {
      return this.$store.state.refreshShopCar;
    }
  },
  methods: {
    // 跳转商品详情
    gotoGoodsDetails(id) {
      this.$router.push("./goodsDetail?id=" + id);
    },
    // 跳转结算页
    gotoOrderInfo() {
      if (this.checkedNum == 0) {
        this.$util.warningMsg("未选择商品");
        return;
      }
      this.$util.setLocalStorage("shopCar", this.checkedList);
      this.$util.setLocalStorage("carCount", {
        originalPrice: this.checkedOriginalPrice,
        checkedPrice: this.checkedPrice
      });
      this.$router.push(`/shop/getOrderInfoFromCar`);
    },
    // 批量删除
    delCarMult() {
      if (!this.checkedList[0]) {
        this.$util.warningMsg("未选择任何商品");
        return;
      }
      let that = this;
      this.$util.elConfirm({
        content: "确定删除选中商品吗",
        confirm() {
          that.saveCar();
        }
      });
    },
    saveCar() {
      let detailList = [];
      let dataList = this.dataList;
      for (let i = 0; i < dataList.length; i++) {
        let _data = {
          shoppingCartGoodsId: dataList[i].ShoppingCartGoodsId
            ? dataList[i].ShoppingCartGoodsId
            : dataList[i].PackagePromotionId,
          shoppingCartGoodsType: dataList[i].isSuit ? 10 : 5,
          quantity: dataList[i].checked ? 0 : dataList[i].BuyCount
        };
        detailList.push(_data);
      }
      if (detailList[0]) {
        this.$util
          .axiosPost({
            url: "/api/MallShoppingCart/BatchUpdateShoppingCartGoods",
            data: {
              UserId: this.userMsg.EmployeeId,
              detailList: detailList
            },
            hideLoading: true
          })
          .then(() => {
            this.getData();
          })
          .catch(() => {});
      }
    },
    // 绑定换购商品
    addHg() {
      let flag = false;
      let _hgList = this.hgList;
      for (let i = 0; i < _hgList.length; i++) {
        if (_hgList[i].checked) {
          this.dataList[this.nowHgIndex].hgGoods = _hgList[i];
          flag = true;
        }
      }
      if (!flag) {
        this.dataList[this.nowHgIndex].hgGoods = {};
      }
      this.showHg = false;
      this.countData();
    },
    // 显示换购弹窗
    hgShow(item, index) {
      this.nowHgIndex = index;
      let _hgList = item.ExchangeBuyPromotion.ExchangeBuyGoodsList;
      let _nowHgChosen = false;
      if (item.canHg) {
        if (item.hgGoods.GoodsId) {
          for (let i = 0; i < _hgList.length; i++) {
            if (_hgList[i].GoodsId == item.hgGoods.GoodsId) {
              _hgList[i].checked = true;
              _nowHgChosen = true;
            }
          }
        }
        this.hgList = _hgList;
        this.showHg = true;
      } else {
        this.$util.warningMsg("未达到换购要求");
      }
      this.nowHgChosen = _nowHgChosen;
    },
    // 隐藏换购弹窗
    hgHide() {
      this.showHg = false;
    },
    // 商品从购物车删除
    delGoods(index) {
      let that = this;
      this.$util.elConfirm({
        content: "确定要从购物车移除该商品吗",
        confirm() {
          let target = that.dataList[index];
          let shoppingCartGoodsType = 5;
          let ShoppingCartGoodsId = "";
          if (target.isSuit) {
            ShoppingCartGoodsId = target.PackagePromotionId;
            shoppingCartGoodsType = 10;
          } else {
            ShoppingCartGoodsId = target.ShoppingCartGoodsId;
          }
          that.$util
            .axiosPost({
              url: "/api/MallShoppingCart/RemoveShoppingCartGoods",
              data: {
                ShoppingCartGoodsId: ShoppingCartGoodsId,
                ShoppingCartGoodsType: shoppingCartGoodsType,
                UserId: that.userMsg.EmployeeId
              }
            })
            .then(() => {
              that.dataList.splice(index, 1);
              if (!that.dataList[0]) {
                that.noData = true;
              }
              that.countData();
            })
            .catch(() => {});
        }
      });
    },
    // 改变商品数量
    handleNumChange(data, value, index) {
      this.dataList[index].BuyCount = value;
      if (Number(value) >= 1) {
        this.$util
          .axiosPost({
            url: "/api/MallShoppingCart/UpdateShoppingCartGoods",
            data: {
              userId: this.userMsg.EmployeeId,
              shoppingCartGoodsId: data.isSuit
                ? data.PackagePromotionId
                : data.ShoppingCartGoodsId,
              shoppingCartGoodsType: data.isSuit ? 10 : 5,
              quantity: value
            },
            hideLoading: true
          })
          .then(res => {
            this.countData();
          })
          .catch(() => {});
      }
    },
    // 勾选单个商品
    chooseItem(item) {
      if (item.State != 5) {
        this.goodStateHandle(item.State);
        return;
      }
      this.countData();
    },
    // 全选
    chooseAll() {
      let _data = this.dataList;
      if (this.checkAll) {
        for (let i = 0; i < _data.length; i++) {
          if (_data[i].State == 5) {
            _data[i].checked = true;
          }
        }
      } else {
        for (let i = 0; i < _data.length; i++) {
          _data[i].checked = false;
        }
      }
      this.countData();
    },
    // 获取购物车数据
    getData() {
      this.$util
        .axiosGet({
          url: "/api/MallShoppingCart/GetShoppingCartGoodsList",
          data: { UserId: this.userMsg.EmployeeId },
          hideLoading: true
        })
        .then(res => {
          let data = res.data;
          if (data.GoodsList.length == 0 && data.PackageList.length == 0) {
            this.noData = true;
            this.dataList = [];
            this.tableDataLength = 0;
            this.countData();
            return;
          }
          // 定义各种状态标识
          for (let i = 0; i < data.GoodsList.length; i++) {
            data.GoodsList[i].checked = false; // 是否选中
            data.GoodsList[i].isSuit = false; // 是否为套装
            data.GoodsList[i].canMs = false; // 是否可以买送
            data.GoodsList[i].msNum = 1; // 满送数量
            data.GoodsList[i].canHg = false; // 是否可以换购
            data.GoodsList[i].hgGoods = {}; // 选中的换购商品
            data.GoodsList[i].zhMoney = data.GoodsList[i].ShopPrice; // 单品促销完的单价(默认原价)
            data.GoodsList[i].zhMoneyCount = data.GoodsList[i].ShopPrice; // 买这个商品的总价（默认单价*1）
            data.GoodsList[i].originalCount = data.GoodsList[i].ShopPrice;
          }
          for (let j = 0; j < data.PackageList.length; j++) {
            data.PackageList[j].checked = false;
            data.PackageList[j].isSuit = true; // 是否为套装
            data.PackageList[j].zhMoneyCount = 0;
            data.PackageList[j].zhMoneySuit = 0;
            data.PackageList[j].originalCount = 0;
            data.PackageList[j].hgGoods = {}; // 选中的换购商品
          }
          this.dataList = [...data.GoodsList, ...data.PackageList];
          this.tableDataLength = this.dataList.length;
          this.countData();
        })
        .catch(() => {});
    },
    // 商品数量统计&优惠计算
    countData() {
      let _hgList = this.hgList;
      let _data = this.dataList;
      for (let i = 0; i < _data.length; i++) {
        // 套装
        if (_data[i].isSuit) {
          _data[i].zhMoneyCount = 0;
          _data[i].originalCount = 0;
          _data[i].zhMoneySuit = 0;
          let _Suit = _data[i].PackageGoodsList;
          for (let s = 0; s < _Suit.length; s++) {
            _Suit[s].zhMoney = _Suit[s].ShopPrice - _Suit[s].Discount;
            _data[i].zhMoneySuit += _Suit[s].zhMoney * _Suit[s].Number;
            _data[i].zhMoneyCount +=
              _Suit[s].zhMoney * _Suit[s].Number * _data[i].BuyCount;
            _data[i].originalCount +=
              _Suit[s].ShopPrice * _Suit[s].Number * _data[i].BuyCount;
          }
        }
        // 单品
        else {
          _data[i].zhMoneyCount = _data[i].ShopPrice * _data[i].BuyCount;
          _data[i].originalCount = _data[i].ShopPrice * _data[i].BuyCount;
          // 判断是否达到换购条件
          if (_data[i].ExchangeBuyPromotion) {
            if (
              _data[i].zhMoneyCount > _data[i].ExchangeBuyPromotion.LimitMoney
            ) {
              _data[i].canHg = true;
            } else {
              _data[i].canHg = false;
              _data[i].hgGoods = {};
              for (let i = 0; i < _hgList.length; i++) {
                _hgList[i].checked = false;
              }
            }
          }
          // 判断是否达到满送条件
          if (_data[i].BuyGivePromotion) {
            let _BuyCount1 = _data[i].BuyCount;
            let _BuyCount2 = _data[i].BuyGivePromotion.BuyCount;
            setTimeout(() => {
              if (_BuyCount1 >= _BuyCount2) {
                _data[i].canMs = true;
                _data[i].msNum =
                  parseInt(
                    _data[i].BuyCount / _data[i].BuyGivePromotion.BuyCount
                  ) * _data[i].BuyGivePromotion.SendCount;
              } else {
                _data[i].canMs = false;
              }
            });
          }
          // 单品促销 lv1
          if (_data[i].SinglePromotion) {
            _data[i].zhMoney = this.SinglePromotionHandle(
              _data[i].SinglePromotion,
              _data[i].ShopPrice
            );
            _data[i].zhMoneyCount = _data[i].zhMoney * _data[i].BuyCount;
          }
          // 换购 lv2
          if (_data[i].hgGoods.ShopPrice) {
            _data[i].zhMoneyCount =
              _data[i].zhMoneyCount + _data[i].ExchangeBuyPromotion.AddMoney;
            _data[i].originalCount =
              _data[i].originalCount + _data[i].ExchangeBuyPromotion.AddMoney;
          }
          // 满减优惠 lv3
          if (_data[i].FullDiscountPromotion) {
            if (
              _data[i].zhMoneyCount >=
              _data[i].FullDiscountPromotion.LimitMoney3
            ) {
              _data[i].zhMoneyCount =
                _data[i].zhMoneyCount -
                _data[i].FullDiscountPromotion.CutMoney3;
            } else if (
              _data[i].zhMoneyCount >=
              _data[i].FullDiscountPromotion.LimitMoney2
            ) {
              _data[i].zhMoneyCount =
                _data[i].zhMoneyCount -
                _data[i].FullDiscountPromotion.CutMoney2;
            } else if (
              _data[i].zhMoneyCount >=
              _data[i].FullDiscountPromotion.LimitMoney1
            ) {
              _data[i].zhMoneyCount =
                _data[i].zhMoneyCount -
                _data[i].FullDiscountPromotion.CutMoney1;
            }
          }
        }
      }
      let _checkedList = [];
      let _checkedNum = 0;
      let _checkedPrice = 0;
      let _checkedOriginalPrice = 0;
      let _checkAll = true;
      for (let n = 0; n < _data.length; n++) {
        if (_data[n].State == 5) {
          if (_data[n].checked) {
            _checkedNum += _data[n].BuyCount;
            _checkedPrice += _data[n].zhMoneyCount;
            _checkedOriginalPrice += _data[n].originalCount;
            _checkedList.push(_data[n]);
          } else {
            _checkAll = false;
          }
        }
      }
      this.checkAll = _checkAll;
      this.checkedList = _checkedList;
      this.checkedNum = _checkedNum;
      this.checkedPrice = this.$util.num2Float(_checkedPrice);
      this.checkedOriginalPrice = this.$util.num2Float(_checkedOriginalPrice);
    },
    // 商品状态处理
    goodStateHandle(state, index) {
      //5 - 正常、10 - 已下架、15 - 已失效、20 - 已过期、25 - 已变更、30 - 异常
      let errText = "";
      switch (state) {
        case "10":
          errText = "已下架";
          break;
        case "15":
          errText = "已失效";
          break;
        case "20":
          errText = "异常";
          break;
      }
      this.$util.elConfirm({
        content: "商品" + errText + "是否移除",
        confirm() {
          this.delGoods(index);
        }
      });
    },
    // 单品促销处理
    SinglePromotionHandle(Promotion, price) {
      if (Promotion.DiscountType == 0) {
        return price * Promotion.DiscountValue * 0.1;
      } else if (Promotion.DiscountType == 1) {
        return price - Promotion.DiscountValue;
      } else if (Promotion.DiscountType == 2) {
        return Promotion.DiscountValue;
      }
    }
  }
};
</script>
<style lang="less" scoped>
.image-ctn {
  margin-right: 20px;
  flex-shrink: 0;
}
.goods-name {
  width: 250px;
  line-clamp: 3;
  -webkit-line-clamp: 3;
}
.suit-price {
  display: inline-block;
  width: 50px;
}
.hg-goods {
  display: flex;
  align-items: center;
}
.show-hg-btn {
  cursor: pointer;
}
.gift-type {
  padding-left: 70px;
}
.goods-type-icon {
  border: 1px solid red;
  background: #ffdedf;
  color: red;
  padding: 0 5px;
  border-radius: 5px;
  margin-right: 5px;
}
.gift-cover {
  width: 70px;
  height: 70px;
  margin-right: 20px;
  margin-left: 30px;
  img {
    max-width: 70px;
    max-height: 70px;
  }
}
.suit-item {
  display: flex;
  align-items: center;
}
.goods-main {
  display: flex;
}
.activity {
  display: flex;
  padding: 5px 0;
}
.promotion-item {
  display: flex;
  margin-right: 20px;
}
.promotion-dir {
  height: 20px;
  line-height: 20px;
  margin-right: 5px;
}
.promotion-type {
  background: red;
  color: white;
  width: 50px;
  height: 20px;
  line-height: 20px;
  text-align: center;
  margin-right: 5px;
}
.order-item {
  margin-bottom: 20px;
  border-right: 1px solid @border3Color;
  border-bottom: 1px solid @border3Color;
  margin-right: -1px;
  .div-table-cell {
    box-sizing: border-box;
    display: flex;
    align-items: center;
    padding-left: 20px;
    border-right: none;
  }
}
.buycar-main {
  width: 1000px;
  margin: 0 auto;
}

.buycar-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
}

.all-goods-num {
  color: @theme;
  font-size: @font-md;
}

.order-title {
  margin-bottom: 20px;
  .div-table-cell {
    line-height: 50px;
    background: @border3Color;
    border-right: none;
    padding-left: 20px;
  }
}

.order-msg {
  display: flex;
  padding: 20px;
  justify-content: space-between;
  align-items: center;
}
.shop-name {
  max-width: 200px;
  margin-right: 20px;
}

.order-footer {
  max-width: 1275px;
  padding-left: 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 20px;
  height: 60px;
  border: 1px solid @border4Color;
}

.order-footer-right {
  height: 100%;
  display: flex;
  align-items: center;
  color: @font3Color;
  > div {
    padding-left: 10px;
  }
}

.all-money {
  > p:nth-child(1) {
    font-size: @font-md;
    padding-bottom: 5px;
  }
  > p:nth-child(2) {
    font-size: @font-xs;
  }
}

.pay-btn {
  cursor: pointer;
  width: 120px;
  padding-left: 0 !important;
  background: @theme;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: @font-md;
  height: 100%;
  margin-left: 20px;
}

.del-ctn {
  display: flex;
  align-items: center;
}

.del-goods {
  cursor: pointer;
  margin-left: 20px;
}
.sh-name {
  margin-left: 10px;
}
.goods-num {
  padding: 20px 0;
  flex-direction: column;
  justify-content: space-around;
}
</style>
